import React, { useState } from 'react'
import { useWlListQuery } from '../store/DianShangYeWuApi';
import { Table, Form, Flex } from 'antd';
import ClientSelect from '../system/client/ClientSelect';   
import IncomeCheck from '../document/income/IncomeCheck';
import ReportCheck from '../document/report/ReportCheck';
import ClientCheck from '../system/client/ClientCheck';
import CostCheck from '../document/cost/CostCheck';
function ArapClientList() {
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const [form] = Form.useForm();
    const [list, setList] = useState([]);
    const [query, setQuery] = useState({
        'wl_qy_id': JSON.parse(localStorage.getItem('jtg-caiwu_qy_id')),
        'wl_dj_type_id': '',
        'wl_dj_id': '',
        'wl_kh_id': JSON.parse(localStorage.getItem('jtg-caiwu_wl_kh_id'))
    });
    const {data, isSuccess} = useWlListQuery(query,{skip:query.wl_kh_id==='',refetchOnMountOrArgChange:1});
    React.useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            let cumulativeBalance = 0; // 累计余额
            const formattedData = data.Result.map((item,index) => {
                // 累计余额 = 前面所有行的金额累计
                cumulativeBalance += Number(item.wl_dj_amount) || 0;
                return {
                    key: item.wl_id,
                    wl_ctime: item.wl_ctime,
                    wl_dj_price: item.wl_dj_price,
                    wl_uname: item.wl_uname,
                    wl_dj_num: item.wl_dj_num,                  
                    wl_uid: item.wl_uid,   
                    wl_dj_type_name: item.wl_dj_type_name,       
                    wl_dj_type_id: item.wl_dj_type_id,       
                    wl_dj_id: item.wl_dj_id,
                    wl_kh_name: item.wl_kh_name,   
                    wl_kh_id: item.wl_kh_id,
                    wl_dj_amount: item.wl_dj_amount,
                    wl_dj_date: item.wl_dj_date,
                    wl_dj_tuanhao: item.wl_dj_tuanhao,
                    wl_balance: cumulativeBalance, // 添加累计余额字段
                    wl_dj_name: item.wl_dj_name,
                    wl_dj_dsbzd_id: item.wl_dj_dsbzd_id,
                    wl_dj_dsbzd_name: item.wl_dj_dsbzd_name,
                };
            });
            //根据wl_dj_date排序
            formattedData.sort((a, b) => new Date(a.wl_dj_date) - new Date(b.wl_dj_date));
            
            setList(formattedData);
        }else{
            setList([]);
        }
    }, [isSuccess, data]);
    const columns = [
        {
            title: '日期',
            dataIndex: 'wl_dj_date',
            width: '5%',
            key: 'wl_dj_date',            
        },      
      
        {
            title: '客户',
            dataIndex: 'wl_kh_name',
            width: '12%',
            key: 'wl_kh_name', 
            render: (text, record) => {
                return <ClientCheck kh_name={record.wl_kh_name} kh_id={record.wl_kh_id} qy_name={record.wl_qy_name} qy_id={record.wl_qy_id} yh_id={record.wl_yh_id} yh_name={record.wl_yh_name}/>
            }
        },       
        {
            title: '应收',
            dataIndex: 'wl_dj_amount',
            width: '5%',
            key: 'wl_dj_amount',
            render: (text, record) => {
                if(record.wl_dj_type_id==='2'){
                    return<span>
                                ￥{(Number(text)*-1).toLocaleString('zh-CN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </span>  
                }else{
                    return <span></span>  
                }}
        },
        {
            title: '应付',
            dataIndex: 'wl_dj_amount',
            width: '5%',
            key: 'wl_dj_amount',
            render: (text, record) => {
                if(record.wl_dj_type_id==='3'||record.wl_dj_type_id==='4'||record.wl_dj_type_id==='5'){
                    return<span>
                                ￥{(Number(text)*-1).toLocaleString('zh-CN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </span>  
                }else{
                    return <span></span>  
                }}  
        },
        {
            title: '余额',
            width: '10%',
            key: 'wl_balance',
            dataIndex: 'wl_balance',
            render: (text, record) => (
                <span style={{color:record.wl_balance>0?'green':'red'}}>
                    {Number(record.wl_balance)>0?'应付':'应收'}
                    ￥{Math.abs(record.wl_balance || 0).toLocaleString('zh-CN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                </span>
            )         
        },
        {
            title: '原始单据',
            dataIndex: 'wl_dj_type_name',
            width: '8%',
            key: 'wl_dj_type_name', 
            render: (text, record) => {
                if(record.wl_dj_type_id === '2') {
                    return <span>收款单 - <IncomeCheck  
                                            ddsr_id={record.wl_dj_id} 
                                            ddsr_uid={record.wl_uid} 
                                            yh_id={yh_id} 
                                            yh_name={yh_name} 
                                            ddsr_bzd_id={record.wl_dj_bzd_id} 
                                            ddsr_bzd_name={record.wl_dj_bzd_name}
                                            ddsr_name={record.wl_dj_name}
                                        /></span>
                }
                if(record.wl_dj_type_id === '3') {
                    return <span>付款单 - <CostCheck  
                                            ddzc_id={record.wl_dj_id} 
                                            ddzc_uid={record.wl_uid} 
                                            yh_id={yh_id} 
                                            yh_name={yh_name} 
                                            ddzc_bzd_id={record.wl_dj_bzd_id} 
                                            ddzc_bzd_name={record.wl_dj_bzd_name}
                                            ddzc_name={record.wl_dj_name}
                                        /></span>
                }
            }
        },     
        {
            title: '团队名称',
            dataIndex: 'wl_dj_dsbzd_name',
            width: '18%', 
            key: 'wl_dj_dsbzd_name',
            render: (text, record) => {
                return <ReportCheck  dsbzd_id={record.wl_dj_dsbzd_id} dsbzd_name={record.wl_dj_dsbzd_name} yh_id={yh_id}  yh_name={yh_name} qy_id={qy_id} qy_name={qy_name}/>
            }
        },
        {
            title: '操作员',
            dataIndex: 'wl_uname',
            width: '10%',
            key: 'wl_uname',
            render: (text, record) => {
                return <>{text} {record.wl_ctime}</>
            }
        },
        {
            title: '编号',
            width: '43',
            key: 'wl_id',
            dataIndex: 'key',            
        }

    ];
    return (
        <>
            <Flex>
                <Form 
                    name='balance' 
                    layout='inline' 
                    form={form}
                    onFinish={(values) => {
                        setQuery(prev => ({...prev,wl_kh_id:values.wl_kh_id}))
                    }}
                    initialValues={{
                        wl_dj_type_id:'',
                        wl_kh_id:(() => {
                            const stored = localStorage.getItem('jtg-caiwu_wl_kh_id');
                            if (!stored) return '';
                            const parsed = JSON.parse(stored);
                            // 统一转换为字符串类型，确保与 options 的 value 类型一致
                            return String(parsed);
                        })()
                    }}
                >
                    <Form.Item name='wl_kh_id'>
                        <ClientSelect
                            wrapperCol={null}
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                            style={{width:'150px'}}
                            defaultId={(() => {
                                const stored = localStorage.getItem('jtg-caiwu_wl_kh_id');
                                if (!stored) return '';
                                const parsed = JSON.parse(stored);
                                // 统一转换为字符串类型，确保与 options 的 value 类型一致
                                return String(parsed);
                            })()}
                            onChange={(value) => {
                                localStorage.setItem('jtg-caiwu_wl_kh_id', JSON.stringify(value || ''));
                                setQuery(prev => ({...prev,wl_kh_id:value || ''}))
                            }}
                        />
                    </Form.Item>                    
                </Form>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                className="custom-table"
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
                locale={{
                    emptyText: '暂无往来数据，请现选择客户！'
                }}
                summary={() => {
                    const total = list.reduce((sum, item) => sum + Number(item.wl_dj_amount), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell index={1}></Table.Summary.Cell>
                            <Table.Summary.Cell index={2}></Table.Summary.Cell>
                            <Table.Summary.Cell index={3} ><div style={{textAlign:'right'}}>合计：</div></Table.Summary.Cell>
                            <Table.Summary.Cell index={4}>
                                    <span style={{color:total>0?'green':'red'}}>
                                    {total>0?'应付':'应收'}
                                    ￥{Math.abs(total || 0).toLocaleString('zh-CN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={5}></Table.Summary.Cell>
                            <Table.Summary.Cell index={6}></Table.Summary.Cell>
                            <Table.Summary.Cell index={7}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    )
                }}
            />
        </>
    )
}

export default ArapClientList